import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-bar-brand',
  templateUrl: './nav-bar-brand.component.html',
  styleUrls: ['./nav-bar-brand.component.scss']
})
export class NavBarBrandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
